import { CharField, MultiSelectField, NumberField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { NamedEntity } from "../../types"
import { NAMED_ENTITY_TYPES } from "../../constants"
import { WysiwygField } from "../../components/WysiwygField"

export default function NamedEntityForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<NamedEntity>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />

      <MultiSelectField
        label="Tipo entità"
        layout="horizontal"
        placeholder="Seleziona un tipo di entità"
        options={NAMED_ENTITY_TYPES}
        value={
          values.entity_types.map((type) => ({
            value: type,
            label: type.charAt(0) + type.slice(1).toLowerCase(),
          })) || []
        }
        onChange={(value) => {
          setFieldValue(
            "entity_types",
            value.map((option) => option.value),
          )
        }}
        isValid={submitCount > 0 ? !getIn(errors, "entity_types") : undefined}
        errorMessage={getIn(errors, "entity_types")}
        required
      />
      <WysiwygField
        label={
          values.entity_types.includes("PHOTOGRAPHER") ||
          values.entity_types.includes("AUTHOR") ||
          values.entity_types.includes("DESIGNER")
            ? "Biografia"
            : "Descrizione"
        }
        layout="horizontal"
        value={values.description || ""}
        onChange={(value) => {
          setFieldValue("description", value)
        }}
      />
      {values.entity_types.includes("PHOTOGRAPHER") ||
      values.entity_types.includes("AUTHOR") ||
      values.entity_types.includes("DESIGNER") ? (
        <>
          <NumberField
            label="Anno di nascita"
            layout="horizontal"
            value={values.year_start}
            onChange={(value) => {
              setFieldValue("year_start", value)
            }}
          />
          <NumberField
            label="Anno di morte"
            layout="horizontal"
            value={values.year_end}
            onChange={(value) => {
              setFieldValue("year_end", value)
            }}
          />
        </>
      ) : null}
      {values.entity_types.includes("EDITOR") ? (
        <CharField
          label="Luogo"
          layout="horizontal"
          value={values.place || ""}
          onChange={(value) => {
            setFieldValue("place", value)
          }}
        />
      ) : null}
    </Col>
  )
}
